import {
  UPLOAD_TAX_CLEARANCE_IMG_FAILED,
  UPLOAD_TAX_CLEARANCE_IMG_REQUEST,
  UPLOAD_TAX_CLEARANCE_IMG_SUCCESS,
  UPLOAD_TAX_CLEARANCE_IMG_LOADING,
  DELETE_UPLOAD_TAX_CLEARANCE_IMG_ERROR,
} from '../../actions/types';

const initialState = {
  photo: '',
  error: '',
  imgLoading: false,
  success: false
};

const uploadTaxClearanceImg = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_TAX_CLEARANCE_IMG_FAILED:
      return {
        ...state,
        error: action.error,
        imgLoading: false
      };
    case UPLOAD_TAX_CLEARANCE_IMG_REQUEST:
      return {
        ...state,
        newstate: action.newstate
      };
    case UPLOAD_TAX_CLEARANCE_IMG_SUCCESS:
      return {
        ...state,
        photo: action.url,
        imgLoading: false,
        success: true
      };
    case UPLOAD_TAX_CLEARANCE_IMG_LOADING:
      return {
        ...state,
        imgLoading: true
      };
    case DELETE_UPLOAD_TAX_CLEARANCE_IMG_ERROR:
      return {
        ...state,
        error: ''
      };

    default:
      return state;
  }
};

export default uploadTaxClearanceImg;
